import React from 'react';
import onClickOutside from 'react-onclickoutside';
import Glyph from './glyph';

class DropMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isOpenUpward: false
    };

    this.onTriggerClick = this.onTriggerClick.bind(this);
  }

  shouldOpenUpward(triggerEl) {
    if (!_.isElement(triggerEl)) {
      return false;
    }

    const windowHeight = window.innerHeight;
    const triggerOffset = triggerEl.getBoundingClientRect();
    const availableSpace = windowHeight - triggerOffset.top;
    const menuItemSpace = 37;
    const menuSpace = this.props.items.length * menuItemSpace;

    return availableSpace < menuSpace;
  }

  toggleOpen(toggle) {
    this.setState({ isOpen: toggle });
  }

  onTriggerClick(e) {
    this.setState({
      isOpenUpward: this.shouldOpenUpward(e.currentTarget)
    });

    this.toggleOpen(!this.state.isOpen);
  }

  // specifically named method for onClickOutside
  handleClickOutside() {
    this.toggleOpen(false);
  }

  renderMenu() {
    if (!this.state.isOpen) {
      return null;
    }

    const menuItems = _.map(this.props.items, (item, i) => {
      return (
        <li key={i}>
          <a href={item.href}>{item.text}</a>
        </li>
      );
    });

    return (
      <ul className="menu">
        {menuItems}
      </ul>
    );
  }

  render() {
    const { isOpen, isOpenUpward } = this.state;
    let className = 'drop-menu';

    if (isOpen) { className += ' is-open'; }
    if (isOpen && isOpenUpward) { className += ' is-open-upward'; }

    return (
      <div className={className}>
        <button
          className="menu-trigger xsm mod-icon"
          onClick={this.onTriggerClick}
        >
          <Glyph name="down-1" />
        </button>
        {this.renderMenu()}
      </div>
    );
  }
}

export default onClickOutside(DropMenu);
